<template>
    <div>
        <!-- ALERT MESSAGE STARTS -->
        <!-- <transition name="fade">
            <div class="alert alertmessage" :class="{'alert-warning' : alert.isError, 'alert-success' : !alert.isError}"
                v-if="alert.showAlert">
                <strong v-if="alert.isError">Error!</strong>
                <strong v-else>Success!</strong>

                <br><br>
                <p v-for="message in alert.alertMessage">♢ {{ message }}</p>
            </div>
        </transition> -->
        <!-- ALERT MESSAGE ENDS -->

        <!-- FILTER START -->
        <!-- <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row outerBox filterBox">
                <div class="col row">
                    <div class="col-md-6 mobileFilterPaddingTop">
                        <label for="partshopCode">Search</label>
                        <input type="text" class="form-control" v-model="filter.search">
                    </div>
                    <div class="col-md-3 offset-md-3 mobileFilterPaddingTop"
                        style="display: flex; flex-direction: column-reverse; padding-top:20px">
                        <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%"
                            @click="vue_universal_table.update++">Filter</button>
                    </div>
                </div>
            </div>
        </panel> -->
        <!-- FILTER END -->

        <div class="innerBox">
            <div class="row">
                <div class="col-md-7 col-12 mt-2">
                    <h3 class="mb-2">Login History</h3>
                </div>
            </div>

            <div class="row">
                <div class="col-md-7 col-12 mt-2 mb-2">
                    <div class="row">
                        <div class="col-md-3 mt-auto mb-auto pl-3">
                            <h5>Pilih Tipe Pencarian :</h5>
                        </div>
                        <div class="col-md-3">
                            <button
                                class="btn w-100"
                                :class="{'btn-warning' : searchType == 'loginHistory' , 'btn-outline-warning' : searchType != 'loginHistory'}"
                                style="border-radius:50px"
                                @click="searchType = 'loginHistory'"
                            >
                                Login History
                            </button>
                        </div>
                        <div class="col-md-3">
                            <button
                                class="btn w-100"
                                :class="{'btn-warning' : searchType == 'aksesModul' , 'btn-outline-warning' : searchType != 'aksesModul'}"
                                style="border-radius:50px"
                                @click="searchType = 'aksesModul'"
                            >
                                Akses Modul
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12 mt-2 mb-2">
                    <!-- <label>Date Filter</label> -->
                    <flat-pickr
                        v-model="selected.date"
                        :config="rangeConfig"
                        placeholder="Pilih Tanggal"
                    />
                </div>
                <div class="col-md-2 col-12 mt-2 mb-2">
                    <!-- <label>Date Filter</label> -->
                    <button
                        class="btn border border-secondary rounded shadow w-100"
                        style="height:43px;"
                        @click="downloadExcel"
                    >
                        <i class="fa fa-download"></i> Download Excel
                    </button>
                </div>
            </div>

            <!-- {{vue_universal_table.curData}} -->
            <div v-if="searchType == 'loginHistory'">
                <vue-universal-table
                    
                    :api_url="'/api/user/userDashboardLog'"
                    :update="vue_universal_table.update"
                    :fields="vue_universal_table.fields"
                    :buttons="vue_universal_table.buttons"
                    :sort_by="'login_time'"
                    :sort_order="'ASC'"
                    :filter="vue_universal_table.filter"

                    @onViewDetails="openViewLoginHistory"
                    @emitData="getTempData"
                >
                </vue-universal-table>
            </div>

            <div v-else>
                <!-- <vue-universal-table
                    :api_url=""
                    :update="vue_universal_table.update"
                    :fields="vue_universal_table.fieldsAkses"
                    :buttons="vue_universal_table.buttons"
                    :filter="vue_universal_table.filter"

                    @onViewDetails="openViewLoginHistory"
                    @emitData="getTempData"
                >
                </vue-universal-table> -->
                <table class="table table-striped mt-3 text-center" v-if="dataAkses">
                    <thead>
                        <th class="tableTitle">User ID</th>
                        <th class="tableTitle">Username</th>
                        <th class="tableTitle">Module</th>
                        <th class="tableTitle">Last Access</th>
                        <th class="tableTitle">
                            <i class="fa fa-cog"></i>
                        </th>
                    </thead>
                    <tbody >
                        <tr v-for="data in dataAkses">
                            <td>{{data.user_id}}</td>
                            <td>{{data.username}}</td>
                            <td>{{data.module}}</td>
                            <td>{{moment(data.last_access).format('MMM DD, YYYY HH:mm')}}</td>
                            <td>
                                <button
                                    class="btn btn-outline-primary"
                                    @click="showModalAkses(data.user_id , data.module , moment(data.last_access).format('Y-MM-DD'))"
                                >
                                    <i class="fa fa-angle-down"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Modal Start -->
        <view-login-history
            v-if="modal.details"
            :data="modal.data"
            @closeModal="modal.details = false"
            :filter="vue_universal_table.filter"
            @refreshTable="vue_universal_table.update++"
        ></view-login-history>

        <view-module-history
            v-if="modal.module"
            :data="modal.data"
            @closeModal="modal.module = false"
            :filter="vue_universal_table.filter"
            @refreshTable="vue_universal_table.update++"
        ></view-module-history>
        <!-- Modal End -->
    </div>
</template>

<script>
    // import newUserModal from './children/newUserModal'
    // import editUserModal from './children/editUserModal'
    import viewLoginHistory from './children/viewLoginHistory.vue'
    import viewModuleHistory from './children/viewModuleHistory.vue'
    import env from '@/env.js'

    import moment from 'moment'
    import flatPickr from 'vue-flatpickr-component'
    const XLSX = require('xlsx')
    import debounce from 'debounce'

    export default {
        name: 'login-history',
        metaInfo: {
            title: 'Login History'
        },
        data() {

            let start = moment().startOf('month').format('Y-MM-DD')
            let end = moment().format('Y-MM-DD')
            return {
                moment,
                searchType : 'loginHistory',
                modal: {
                    details: null,
                    module : false,
                    data : {
                        user_id : null,
                        module : null
                    }
                },
                rangeConfig : {
                    mode : 'range',
                    dateFormat : 'Y-m-d',
                    altInput : true,
				    altInputClass: 'form-control input flatpickr-input',
                    altFormat: "j M Y"
                },
                selected : {
                    date : `${start} to ${end}`
                },
                vue_universal_table: {
                    curData : null,
                    update: 0,
                    fields: [
                        {
                            title: 'Username',
                            variable: 'username'
                        },
                        {
                            title: 'Type',
                            variable: 'type'
                        },
                        {
                            title: 'Login Time',
                            variable: 'login_time'
                        },
                        {
                            title: 'Last Login Time',
                            variable: 'last_login_time'
                        }
                    ],
                    fieldsAkses : [
                        {
                            title : 'User ID',
                            variable : 'user_id'
                        },
                        {
                            title : 'Username',
                            variable : 'username'
                        },
                        {
                            title : 'User Type',
                            variable : 'type'
                        },
                        {
                            title : 'Module',
                            variable : 'module'
                        },
                        {
                            title : 'Last Access',
                            variable : 'last_access'
                        }
                    ],
                    buttons: [
                        {
                            title: 'viewDetails',
                            class: 'fas fa-chevron-down btn-outline-primary',
                            variable: 'user_id'
                        },
                    ],
                    process_data : `
                        for (var i in data) {
                            data[i].username = data[i].username ? data[i].username : '-'
                            data[i].type = data[i].type ? data[i].type : '-'
                            data[i].login_time = data[i].login_time ? data[i].login_time : '-'
                            data[i].last_login_time = data[i].last_login_time ? data[i].last_login_time : '-'
                        }
                    `,
                    filter : {
                        start : start,
                        end : end
                    },
                    filterModule : {
                        date : start
                    }
                    // special_buttons: ['addUser']
                },
                dataAkses : null
            }
        },
        watch : {
            'selected.date' () {
                let dates = this.selected.date.split(" to ");

                let start;
                let end;
                if (dates.length == 1) start = end = dates[0];
                else {
                    start = dates[0];
                    end = dates[1];
                }

                this.vue_universal_table.filter.start = start;
                this.vue_universal_table.filter.end = end;
                this.debounceLoadData();
            },
            searchType () {
                this.vue_universal_table.update++;
            },
            'vue_universal_table.update' : function () {
                if(this.searchType == 'aksesModul')
                    this.loadData()
            }
        },
        components: {
            viewLoginHistory,
            viewModuleHistory,
            flatPickr
        },
        mounted() {

        },
        methods: {
            loadData () {
                let url = env.urlStartLog + '/api/activity-history?'

                url = this.initialiseFilter(url , this.vue_universal_table.filter)

                this.$http.get(url)
                .then((resp) => {
                    this.dataAkses = resp.data.data
                })
                .catch((err) => {
                    console.log(err)
                })
            },
            openViewLoginHistory (user_id) {
                this.modal.data.user_id = user_id
                this.modal.details = true;
            },
            showModalAkses(user_id , module , date) {
                this.modal.data.user_id = user_id
                this.modal.data.module = module
                this.modal.data.date = date
                this.modal.module = true;
            },
            debounceLoadData: debounce(function (e) {
                this.vue_universal_table.update++;
            }, 2000),
            getTempData(data) {
                this.vue_universal_table.curData = data
            },
            async downloadExcel () {
                try {
                    let wb = XLSX.utils.book_new()
                    let exportFileName = 'Login History User.xlsx';

                    let processedData = this.vue_universal_table.curData;

                    for(var i = 0 ; i < processedData.length ; i++) {
                        let curUser = processedData[i]
                        let loginHistory = await this.getLoginHistoryPerUser(curUser.user_id)

                        var ws = XLSX.utils.json_to_sheet(loginHistory, {raw:true});
                        XLSX.utils.book_append_sheet(wb, ws, `${curUser.user_id} - ${curUser.username}`)
                    }

                    XLSX.writeFile(wb, exportFileName)
                }
                catch(err) {

                }
            },
            async getLoginHistoryPerUser (user_id) {
                try {

                    let filter = this.vue_universal_table.filter
                    let url ='/api/user/userDashboardLogDetails?id=' + user_id + '&'
                    url = this.initialiseFilter(url , filter)
                    // url = this.initialiseFilter(url , this.data)

                    let resp = await this.$http.get(url)

                    return resp.data.data
                }
                catch(err) {
                    console.log(err)
                }
            }
        }
    }
</script>

<style>
    /* ALERT MESSAGE STARTS */
    .alertmessage {
        position: fixed;
        top: 10%;
        left: 47.5%;
        z-index: 9999;
        width: 300px;
        text-align: center;
    }

    .alertmessage strong {
        font-size: 150%
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
        {
        opacity: 0;
    }

    /* ALERT MESSAGE ENDS */
</style>